import { useParams } from "react-router-dom";
import "./styles.css";
export default function DemanderService() {
    const { service, step } = useParams();

    return(
        <main className="mainDemanderService">
            <div>
                {service} {step}
            </div>
        </main>
    )

}